import * as React from "react";
import axios from "axios";
import Button from "@material-ui/core/Button";
import { DubitoSvc } from "../../api";
import {
  List,
  ListItem,
  ListItemText,
  Typography,
  Icon,
  Avatar,
  IconButton,
  TablePagination,
  Tabs,
  Tab,
  Chip,
  Badge,
  Card,
  createStyles,
  withStyles
} from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import * as moment from "moment";
import MomentUtils from "material-ui-pickers/utils/moment-utils";

import EnhancedTable from "./table";
import { Case, User, Category, Tag, Report } from "../../api/classes";
//import cookie from 'react-cookie'
import FilterListIcon from "@material-ui/icons/FilterList";
import SortIcon from "@material-ui/icons/SwapVert";
import ExportIcon from "@material-ui/icons/CloudDownload";

import { connect, Dispatch } from "react-redux";
import { GlobalState } from "../../store";
import * as actions from "../../store/cases/actions";
import Select from "react-select";
import FilterView from "../../components/filter";
import { ButtonBaseProps } from "@material-ui/core/ButtonBase";
import DatePicker from "material-ui-pickers/DatePicker";
import MuiPickersUtilsProvider from "material-ui-pickers/utils/MuiPickersUtilsProvider";
import { CSVLink } from "react-csv";
import { Link } from "react-router-dom";
import Loading from "../../components/loading";
import AddReportButton from "./addReportButton";
import FolderIcon from "@material-ui/icons/Folder";
import ReportListItem from "./reportListItem";
import {
  SOURCE_INSTAGRAM_MESSAGE,
  SOURCE_WHATSAPP,
  SOURCE_TWITTER_MENTION,
  SOURCE_TWITTER_MESSAGE,
  SOURCE_FACEBOOK,
  SOURCE_OTHER
} from "src/api/constants";
import EmptyState from "src/components/emptyState";
import { DEFAULT_AVATAR } from "src/auth/auth";

interface Props {
  classes: any;
  cases: Case[];
  users: User[];
  categories: Category[];
  reports: Report[];
  tags: Tag[];
  fetchCases: () => void;
  fetchUsers: () => void;
  fetchCategories: () => void;
  fetchTags: () => void;
  fetchReports: () => void;
}
interface State {
  cases: Case[];
  page: number;
  rowsPerPage: number;
  filterOpen: boolean;
  sortOpen: boolean;
}
function CustomTab(props: ButtonBaseProps) {
  return (
    <div>
      {props.children} + {props.title}
    </div>
  );
}
const styles = theme =>
  createStyles({
    toolbar: {
      flexWrap: "wrap",
      justifyContent: "flex-end",
      marginBottom: 8,
      marginTop: 8
    }
  });
class CaseList extends React.Component<Props> {
  state = {
    reports: this.props.reports,
    page: 0,
    rowsPerPage: 25,
    filterOpen: true,
    sortOpen: false,
    userFilters: [],
    stateFilters: [],
    categoryFilters: [],
    tagFilters: [],
    folder: "news_feed",
    startDate: null,
    endDate: null
  };
  componentDidMount() {
    if (!this.props.reports) {
      this.props.fetchReports();
    }
  }
  componentWillReceiveProps(next: Props) {
    this.setState({ reports: next.reports });
  }
  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };
  toggleFilterView = () => {
    this.setState({ filterOpen: !this.state.filterOpen, sortOpen: false });
  };
  toggleSortView = () => {
    this.setState({ sortOpen: !this.state.sortOpen, filterOpen: false });
  };
  renderSort() {
    if (this.state.sortOpen) {
      return (
        <div style={{ height: 200 }}>
          <Typography>Sort</Typography>
          <Divider />
        </div>
      );
    }
    return null;
  }
  filterReports() {
    let reports = this.props.reports.copyWithin(0, 0);
    const { userFilters, stateFilters, categoryFilters } = this.state;
    if (stateFilters.length !== 0) {
      reports = reports.filter(c => {
        if (stateFilters.length > 0) {
          if (stateFilters.find(u => u.value === c.source)) {
            return true;
          }
        }
      });
    }
    if (this.state.startDate !== null) {
      reports = reports.filter(c => {
        if (moment(c.created_at).isAfter(this.state.startDate)) {
          return true;
        }
      });
    }
    if (this.state.endDate !== null) {
      reports = reports.filter(c => {
        if (moment(c.created_at).isBefore(this.state.endDate)) {
          return true;
        }
      });
    }
    this.setState({ reports });
  }
  renderFilter() {
    if (!this.props.reports) {
      return;
    }
    if (this.state.filterOpen) {
      return (
        <div style={{}}>
          <Card style={{ marginTop: 24, marginBottom: 24, padding: 24 }}>
            <FilterView
              theme
              values={this.state.stateFilters}
              suggestions={[
                {
                  label: "Facebook Message",
                  value: SOURCE_FACEBOOK,
                  backgroundColor: "#3b5998",
                  color: "#ffffff"
                },
                {
                  label: "Twitter DM",
                  value: SOURCE_TWITTER_MESSAGE,
                  backgroundColor: "#1da1f2",
                  color: "#ffffff"
                },
                {
                  label: "Twitter Mention",
                  value: SOURCE_TWITTER_MENTION,
                  backgroundColor: "#1da1f2",
                  color: "#ffffff"
                },
                {
                  label: "Whatsapp",
                  value: SOURCE_WHATSAPP,
                  backgroundColor: "#25d366",
                  color: "#ffffff"
                },
                {
                  label: "Instagram",
                  value: SOURCE_INSTAGRAM_MESSAGE,
                  backgroundColor: "#cd486b",
                  color: "#ffffff"
                },
                {
                  label: "Other",
                  value: SOURCE_OTHER,
                  backgroundColor: "gray",
                  color: "#ffffff"
                }
              ]}
              title="Source"
              placeholder="Facebook, Twitter Message, Whatsapp"
              onChange={(values: any[]) => {
                //console.log(values);
                this.setState({ stateFilters: values }, () => {
                  this.filterReports();
                });
              }}
            />
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <div
                style={{
                  marginTop: 24,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-end"
                }}
              >
                <Typography
                  variant="caption"
                  style={{ fontSize: 16, marginBottom: 5 }}
                >
                  From
                </Typography>
                <DatePicker
                  clearable
                  style={{
                    marginLeft: 16,
                    marginRight: 16,
                    textAlign: "center"
                  }}
                  format="LL"
                  placeholder="Day 0"
                  value={this.state.startDate}
                  onChange={m => {
                    this.setState(
                      { startDate: m ? m.toISOString() : null },
                      () => this.filterReports()
                    );
                  }}
                />
                <Typography
                  variant="caption"
                  style={{ fontSize: 16, marginBottom: 5 }}
                >
                  Until
                </Typography>

                <DatePicker
                  clearable
                  placeholder="Today"
                  style={{ marginLeft: 16 }}
                  format="LL"
                  value={this.state.endDate}
                  onChange={m => {
                    this.setState({ endDate: m ? m.toISOString() : null }, () =>
                      this.filterReports()
                    );
                  }}
                />
              </div>
            </MuiPickersUtilsProvider>
          </Card>
          <Divider />
        </div>
      );
    }
    return null;
  }
  handleTabChange = (event, value) => {
    this.setState({ folder: value });
  };
  get filterCount() {
    let count =
      this.state.stateFilters.length +
      this.state.userFilters.length +
      this.state.categoryFilters.length;

    if (this.state.startDate) {
      count++;
    }
    if (this.state.endDate) {
      count++;
    }
    return count;
  }
  render() {
    if (!this.state.reports) {
      return <Loading />;
    }
    const { reports, rowsPerPage, page } = this.state;
    const pagination = (
      <TablePagination
        style={{ flex: 1 }}
        component="div"
        classes={{ toolbar: this.props.classes.toolbar }}
        count={reports.length}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[5, 10, 25, 50, 100]}
        page={page}
        backIconButtonProps={{
          "aria-label": "Previous Page"
        }}
        nextIconButtonProps={{
          "aria-label": "Next Page"
        }}
        onChangePage={this.handleChangePage}
        onChangeRowsPerPage={this.handleChangeRowsPerPage}
      />
    );
    return (
      <div
        style={{
          flex: 1,
          padding: 24,
          paddingBottom: 96,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          overflowY: "scroll"
        }}
      >
        {/*         <EnhancedTable data={this.state.cases} />
         */}
        <div
          style={{
            width: "100%",
            maxWidth: 1000,
            marginLeft: 24,
            marginRight: 24
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap-reverse"
            }}
          >
            <div style={{ flexShrink: 1, flexGrow: 1 }}>
              <Typography>Reports</Typography>
            </div>
            <div style={{ flexGrow: 1 }} />
            <CSVLink data={this.state.reports}>
              <IconButton aria-label="Download">
                <ExportIcon />
              </IconButton>
            </CSVLink>
            <IconButton aria-label="Filter list" onClick={this.toggleSortView}>
              <SortIcon />
            </IconButton>
            <Badge badgeContent={this.filterCount} color="primary">
              <IconButton
                aria-label="Filter list"
                onClick={this.toggleFilterView}
              >
                <FilterListIcon />
              </IconButton>
            </Badge>
          </div>
          <Divider />

          {this.renderSort()}
          {this.renderFilter()}
          {pagination}
          <List>
            {this.props.reports.length === 0 && (
              <EmptyState message="There is no report yet. You may create one by pressing + icon at the bottom." />
            )}

            {this.state.reports
              .sort((a, b) => {
                return b.id - a.id;
              })
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((i: Report) => {
                return <ReportListItem report={i} />;
              })}
          </List>
          {pagination}
          <AddReportButton />
        </div>
      </div>
    );
  }
  renderCategory(category_id) {
    let text = category_id;
    if (this.props.categories) {
      const cat = this.props.categories.find(i => i.id === category_id);
      if (cat) {
        text = cat.title;
      }
    }
    return (
      <Typography style={{ marginLeft: 8 }} variant="body2">
        {text}
      </Typography>
    );
  }
  renderUser(user_id) {
    const user =
      this.props.users && this.props.users.find(e => e.id === user_id);
    if (user) {
      return (
        <div style={{ display: "flex", flexDirection: "row", marginLeft: 12 }}>
          <Avatar
            style={{ width: 20, height: 20 }}
            src={user.account_picture || DEFAULT_AVATAR}
          />
          <Typography style={{ marginLeft: 8, fontSize: 13 }} variant="body2">
            {user.name}
          </Typography>
        </div>
      );
    } else {
      return null;
    }
  }
  renderSource(status) {
    let color = "#ffffff00",
      text = "status";
    if (status === "twitter:message") {
      color = "#ff9800";
      text = "Twitter DM";
    } else if (status === "twitter:mention") {
      color = "#ff5722";
      text = "Twitter";
    } else if (status === "whatsapp") {
      color = "green";
      text = "WhatsApp";
    } else if (status === "facebook:message") {
      color = "blue";
      text = "Facebook";
    }
    return (
      <Typography
        style={{
          marginLeft: 16,
          backgroundColor: color,
          color: "white",
          padding: 2,
          paddingLeft: 8,
          paddingRight: 8,
          borderRadius: 6,
          fontSize: 14,
          alignSelf: "flex-end"
        }}
        variant="caption"
      >
        {text}
      </Typography>
    );
  }
}
export default connect(
  (state: GlobalState, own: any) => ({
    reports: state.cases.reports
  }),
  dispatch => ({
    fetchReports: (): any => dispatch(actions.fetchReports())
  })
)(withStyles(styles)(CaseList));



// WEBPACK FOOTER //
// ./src/pages/reports/index.tsx